import {Component, OnInit, Renderer2, ViewChild, OnDestroy, TemplateRef} from '@angular/core';
import {ScreenService} from '../services/screen.service';
import {Horarios} from '../modelo/horarios';
import {HttpService} from '../services/http.service';
import {Subscription} from 'rxjs/Subscription';
import {ActivatedRoute} from '@angular/router';
import {colors} from '../../calendario/utils/color';
import {Subject} from 'rxjs';
import {CalendarEvent} from 'angular-calendar';
import {addDays, isFriday, isMonday, isThursday, isTuesday, isWednesday, startOfWeek} from 'date-fns';
import {LoginService} from '../../../pages/services/login.service';

@Component({
  selector: 'app-agenda',
  templateUrl: './agenda-maestro.component.html',
  styleUrls: ['./agenda-maestro.component.css'],
  providers: [ScreenService]
})

export class AgendaMaestroComponent implements OnInit, OnDestroy {

  // Suscripciones
  horariosSubscrition: Subscription = new Subscription();

  horarios: Horarios;
  height: any;
  profesores: any[] = [];
  asignaturas: any[] = [];
  aula: any[] = [];
  id: number;
  curso: string;

  @ViewChild('modalContent', {static: true}) modalContent: TemplateRef<any>;
  refresh: Subject<any> = new Subject();
  viewDate: Date = new Date();

  start: any;
  end: any;

  asignaturasMostrar: CalendarEvent[] = [];

  constructor(
              private _http: HttpService,
              private _router: ActivatedRoute,
              private _login: LoginService) {
    this._http.getHorariosProfesor(this._login.getIdentity().id);
  }

  ngOnInit() {
    this.horariosSubscrition = this._http.horarios$.subscribe(resHorarios => {
      this.aula = resHorarios;
      this.mostrarClasesEnCalendario();
    });
  }

  mostrarClasesEnCalendario() {
    this.asignaturasMostrar = [];
    const principioSemanaActual = addDays(startOfWeek(new Date()), 1);
    this.aula.forEach(clase => {
      clase = this.actualizarFechaParaMostrar(clase, principioSemanaActual);

        this.asignaturasMostrar = [
          ...this.asignaturasMostrar, {
            id: clase.id,
            start: new Date(clase.start),
            end: new Date(clase.fin),
            title: this.asignaturaFormatter(clase),
            color: colors[colors.findIndex(color => color.name === clase.color)],
            allDay: false,
          }
        ];

    });
  }

  asignaturaFormatter(clase: any) {
    return '<strong>' + clase.asignatura + '</strong>';
  }

  actualizarFechaParaMostrar(clase: any, principioSemanaActual: any) {
    switch (true) {
      case isMonday(clase.start): {
        return this.setDiaEnSemanaActual(clase, principioSemanaActual, 0);
      }
      case isTuesday(clase.start): {
        return this.setDiaEnSemanaActual(clase, principioSemanaActual, 1);
      }
      case isWednesday(clase.start): {
        return this.setDiaEnSemanaActual(clase, principioSemanaActual, 2);
      }
      case isThursday(clase.start): {
        return this.setDiaEnSemanaActual(clase, principioSemanaActual, 3);
      }
      case isFriday(clase.start): {
        return this.setDiaEnSemanaActual(clase, principioSemanaActual, 4);
      }
      default: {
        return clase;
      }
    }
  }

  setDiaEnSemanaActual(clase: any, principioSemanaActual: any, amount: number) {
    const anyo = addDays(principioSemanaActual, amount).getFullYear();
    const mes = addDays(principioSemanaActual, amount).getMonth();
    const dia = addDays(principioSemanaActual, amount).getDate();
    clase.start = new Date(clase.start).setFullYear(anyo, mes, dia);
    clase.fin = new Date(clase.fin).setFullYear(anyo, mes, dia);
    return clase;
  }

  ngOnDestroy() {
    this.horariosSubscrition.unsubscribe();
  }
}
